import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-add',
  standalone: true,
  imports: [],
  templateUrl: './icon-add.component.html',
  styleUrl: './icon-add.component.scss'
})
export class IconAddComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24px';
}
